import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { shareReplay } from 'rxjs/operators';
import {EmployeeStatus} from "../domain/employee-status";

@Injectable({
  providedIn: 'root',
})

export class StatusesService {
  readonly statuses$ = this.httpClient.get<EmployeeStatus[]>(`${ environment.api }/employee-status`).pipe(
    shareReplay(1),
  );

  constructor(private httpClient: HttpClient) { }
}
